<template>
	<div>
		<div class="header">
			<img src="../../assets/module/html5/liangfantuan_header.png" alt="" />
			<img class="header-btm" src="../../assets/module/html5/liangfantuan_header_btm.png" alt="" />
		</div>
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh" :headHeight="100">
			<nut-infiniteloading @loadmore="onInfinite" :is-show-mod="true" :has-more="isHasMore" :is-loading="isGoodsLoading" :threshold="200">
				<div class="top-goods-list">
					<div class="top-goods" v-for="(item, index) in afterGoods" :key="index" @click="detail({ itemid: item.goods_numiid, shopType: 1 })">
						<i class="top-goods-icon"></i>
						<div class="top-goods-img"><img :src="item.goods_picture" alt="" /></div>
						<div class="top-goods-info">
							<div class="top-goods-title">{{ item.goods_title }}</div>
							<div class="top-goods-btm">
								<div class="top-goods-price-p">
									￥
									<span>{{ item.goods_yprice }}</span>
									券后
								</div>

								<div class="top-goods-desc">{{ item.goods_info }}</div>
							</div>
						</div>
					</div>
				</div>

				<div class="btm-goods-list">
					<div class="btm-goods" v-for="(item, index) in CouponData" :key="index" @click="detail({ itemid: item.goods_numiid, shopType: 1 })">
						<div class="btm-goods-img"><img :src="item.goods_picture" alt="" /></div>
						<div class="btm-goods-title">{{ item.goods_title }}</div>
						<div class="btm-goods-price-p">
							￥
							<span>{{ item.goods_yprice }}</span>
							券后
						</div>

						<div class="btm-goods-desc">{{ item.goods_info }}</div>
					</div>
				</div>
			</nut-infiniteloading>
		</van-pull-refresh>

		<nut-backtop :distance="400"></nut-backtop>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isLoading: false,
			CouponData: [],
			afterGoods: [],
			page: 0,
			isHasMore: true,
			isGoodsLoading: false
		};
	},
	created() {
		this.loadData();
	},

	methods: {
		onRefresh() {
			this.page = 0;
			this.loadData('onRefresh');
		},
		loadData(type) {
			this.isGoodsLoading = true;
			this.$Request.post('search/baodan', { page: this.page, limit: 20 }).then(res => {
				this.isGoodsLoading = false;
				if (res.code == 200) {
					if (this.page == 0) {
						this.afterGoods = res.data.slice(0, 2);
						this.CouponData = res.data.splice(2, res.data.length);
					} else {
						res.data.forEach(item => {
							this.CouponData.push(item);
						});
					}
				} else {
					this.isHasMore = false;
				}
				if (type == 'onRefresh') {
					this.isLoading = false;
				}
			});
		},
		onInfinite() {
			this.page = this.page + 1;
			this.loadData();
		},
		detail(e) {
			suni.showLoading();
			suni.navigateTo({
				url: '/pages/detail/goodsinfo?itemid=' + e.itemid + '&goods_type=' + e.shopType
			})
				.then(res => {
					suni.hideLoading();
				})
				.catch(err => {
					console.log(err);
					suni.hideLoading();
				});
		}
	}
};
</script>

<style>
body {
	background: #db3552;
}
.top-goods {
	display: -webkit-flex;
	display: flex;
	position: relative;
	padding: 15px;
	border-radius: 15px;
	background-image: linear-gradient(-90deg, #fff4e5, #ffd9a7);
	margin-bottom: 20px;
}

.top-goods .top-goods-icon {
	position: absolute;
	top: 10px;
	left: -15px;
	width: 80px;
	height: 30px;
	background: url(https://static.fenxianglife.com/ui/h5-activity/2019-03/liangfantuan/bk_icon.png) no-repeat 50% / cover;
}

.top-goods .top-goods-img {
	width: 150px;
	height: 150px;
	margin-right: 10px;

	overflow: hidden;
}

.top-goods .top-goods-img img {
	display: block;
	width: 100%;
	height: 100%;
}

.top-goods .top-goods-info {
	-webkit-flex: 1;
	flex: 1;
	display: -webkit-flex;
	display: flex;
	-webkit-flex-direction: column;
	flex-direction: column;
	-webkit-justify-content: space-between;
	justify-content: space-between;
}

.top-goods .top-goods-info .top-goods-title {
	font-size: 15px;
	line-height: 20px;
	color: #222;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-all;
	height: 42px;
}

.top-goods .top-goods-info .top-goods-btm .top-goods-price-p {
	color: #dd324f;
	font-size: 20px;
	margin-bottom: 25px;
}

.top-goods .top-goods-info .top-goods-btm .top-goods-price-p span {
	font-size: 20px;
	font-weight: 700;
}

.top-goods .top-goods-info .top-goods-btm .top-goods-price-j {
	display: inline-block;
	color: #dd324f;
	border: 1px solid #dd324f;
	border-radius: 2px;
	font-size: 16px;

	text-align: center;
	padding: 3px 6px;
	margin: 8px 0 8px 8px;
}

.top-goods .top-goods-info .top-goods-btm .top-goods-desc {
	background: #dd324f;
	/* 	margin-top: .25rem; */
	color: #fff;
	text-align: center;
	font-size: 14px;
	line-height: 20px;
	border-radius: 5px;
	padding: 5px;
	border-radius: 10px;
}

.btm-goods {
	float: left;
	background: #fff;
	width: 48.8%;
	border-radius: 5px;
	box-sizing: border-box;
	margin-bottom: 10px;
	padding: 10px 10px 5px;
}

.btm-goods:nth-child(2n) {
	float: right;
}

.btm-goods .btm-goods-img {
	width: 100%;
	height: 150px;
	margin-bottom: 10px;
}

.btm-goods .btm-goods-img img {
	display: block;
	width: 100%;
	height: 100%;
}

.btm-goods .btm-goods-title {
	font-size: 15px;
	line-height: 20px;
	height: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin-bottom: 5px;
}

.btm-goods .btm-goods-price-p {
	color: #e83239;
	font-size: 14px;
	margin-bottom: 10px;
}

.btm-goods .btm-goods-price-p span {
	font-size: 16px;
	font-weight: 700;
}

.btm-goods .btm-goods-price-j {
	display: inline-block;
	color: #e83239;
	border: 1px solid #dd324f;
	border-radius: 3px;
	font-size: 14px;
	line-height: 14px;
	text-align: center;
	padding: 3px 6px;
	margin: 5px 0 5px 5px;
}

.btm-goods .btm-goods-desc {
	background: #dd324f;
	color: #fff;
	text-align: center;
	font-size: 13px;
	padding: 3px 5px;
	border-radius: 3px;
	line-clamp: 1;
}

.header {
	position: relative;
}

.header img {
	display: block;
	width: 100%;
}

.header img.header-btm {
	position: absolute;
	bottom: 0;
}

.top-goods-list {
	padding: 10px;
	background: #db3552;
}

.btm-goods-list {
	padding: 0 10px;
	overflow: hidden;
	background: #db3552;
}

.nomore {
	color: #eee;
	text-align: center;
	font-size: 0.875rem;
	background: #db3552;
	padding: 1rem 0;
}
.bottom-tips .tips-txt {
	color: #ffffff !important;
}
.van-pull-refresh__head {
	color: #ffffff !important;
}
</style>
